import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { Counter } from '../../Counter'
import { EMAIL_ACCOUNT_TYPE_DESCRIPTION_KEYS } from '../../Email'
import { FloatingTooltip, FloatingTooltipContentText } from '../../Floating'
import Text from '../../Text'

import * as styles from './MyUnreadEmailsWidgetItemContent.module.css'

function MyUnreadEmailsWidgetItemContent({
  accountType,
  children,
  className = styles.MyUnreadEmailsWidgetItemContent,
  text,
  textClassName = styles.text,
  unread,
  onClickTitle,
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <div className={className}>
      <div className={styles.accountInfoContainer}>
        <FloatingTooltip
          content={
            <FloatingTooltipContentText
              additionalText={t('Common.ClickToOpenProfileKey')}
              text={text}
            />
          }
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text className={textClassName} onClick={onClickTitle}>
            {text}
          </Text>
        </FloatingTooltip>
        <FloatingTooltip
          content={t(EMAIL_ACCOUNT_TYPE_DESCRIPTION_KEYS[accountType])}
          disabled={!overflow}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text
            isSecondary
            className={styles.accountType}
            ref={setContentOverflowRef}
          >
            {t(EMAIL_ACCOUNT_TYPE_DESCRIPTION_KEYS[accountType])}
          </Text>
        </FloatingTooltip>

        {children}
      </div>
      {unread > 0 ? <Counter count={unread} /> : null}
    </div>
  )
}

export default MyUnreadEmailsWidgetItemContent
